import React, { Component } from 'react';

import TimerScreen from './TimerScreen.js';
import moment from 'moment';


class TimerScreenContainer extends Component {
    constructor(props){
        super(props);
        this.initialState = {};
        this.state = this.initialState;
    }
    formatTime(ms) {
        if (ms > 0) {
            return moment.utc(ms).format('mm:ss');
        }
        else {
            return null;
        }
    }
    getFormattedDuration(challenge) {
        return this.formatTime(challenge.duration*1000);
    }
    onChange(event) {
        this.setState({[event.target.name]:event.target.value});
    }
    render() {
        var challenge = this.props.challenge;
        return <TimerScreen 
                   {...this.props}
                   challenge={challenge}
                   formattedDuration={this.getFormattedDuration(challenge)}
                   duration={challenge.duration*1000}
                   completePending={this.props.completePending} />;
    }

}

export default TimerScreenContainer;



// WEBPACK FOOTER //
// ./src/modules/challenges/types/screens/TimerScreenContainer.js